// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".topMenuShortDropdown {\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n}\n.toptabshort {\n  width: 26px;\n  height: 26px;\n  margin-right: 10px;\n}\n.toptabshort i {\n  margin-top: -8px;\n  margin-left: -6px;\n}\n.topMenuShort {\n  min-width: 200px;\n  max-height: 289px;\n}\n.topMenuShort *:hover {\n  text-decoration: none;\n}\n.topMenuShort i {\n  font-size: 11px !important;\n}\n.topMenuShort .q-item__label {\n  padding-left: 10px;\n}", ""]);
// Exports
module.exports = exports;
